export default "__VITE_ASSET__Dikvw8aU__"